import { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { FaRegCheckCircle, FaCheck } from "react-icons/fa";

export default function Form() {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    // Функція для отримання значення з cookie
    const getCookie = (cookieName) => {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArr = decodedCookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    };

    const currentPath = window.location.pathname;
    const isEn = currentPath.startsWith("/en");

    const [preloader, preloaderFormStyle] = useState("hidden");
    const [promoAlert, setPromoAlertData] = useState("");
    const [promoAlertStyle, setPromoAlerStyle] = useState("");

    const [event, setEvent] = useState({});

    const errorStyle =
        "absolute -top-2 right-0 text-red-800 z-10 bg-white text-[13px] px-[4px] leading-none rounded-r flex items-center";
    const successStyle =
        "absolute top-0 right-0 text-[#003366] z-10 text-sm h-full p-[4px] leading-none rounded-full flex items-center";

    const domain = window.location.protocol + "//" + window.location.host;

    const inputStyle = "font-medium text-base text-[#245864] appearance-none border-[1px] border-x-0 border-t-0 border-b-[#245864] w-full pb-4 placeholder:text-[#245864] bg-transparent"

    const clearDataPromo = async (data) => {
        var promocodeData = {
            promocode: data,
            site_name: domain,
            action: "checkpromo",
        };

        try {
            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-she/ekonomika-requests.php",
                promocodeData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 201 || response.status === 200) {
                if (response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(<FaCheck />);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const onSubmit = async (data) => {
        try {
            preloaderFormStyle("flex");

            // Надіслати подію в GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_send',
                formType: 'Contact',
            });

            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-she/ekonomika-requests.php",
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.data.check !== false) {
                window.location.href = response.data;
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            preloaderFormStyle("hidden");
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if (value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    // URL params
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";
    const utm_content = searchParams.get("utm_content") || "";

    // Translated texts
    const priceNote = isEn ? "* Price before tax" : "* Ціна до оподаткування";
    const emailError = isEn ? "enter email" : "вкажіть email";
    const phoneError = isEn ? "enter phone" : "вкажіть телефон";
    const submitText = isEn ? "Submit" : "Надіслати";
    const waitText = isEn ? "Please wait..." : "Зачекайте...";
    const price = isEn ? "uah" : "грн";

    useEffect(() => {
        setValue("user_agent", navigator.userAgent);

        // Зчитування cookie _fbc та _fbp
        const fbc = getCookie("_fbc");
        const fbp = getCookie("_fbp");
        if (fbc) setValue("fbc", fbc);
        if (fbp) setValue("fbp", fbp);

        // Отримання IP-адреси за допомогою зовнішнього API
        const fetchIpAddress = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json"); // Використовуємо ipify API
                setValue("user_ip", response.data.ip);
            } catch (error) {
                console.error("Не вдалося отримати IP-адресу: ", error);
                setValue("user_ip", "");
            }
        };

        fetchIpAddress();
    }, [setValue]);

    return (
        <div className="flex-1">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-4 relative">
                    <input
                        type="email"
                        name="email"
                        {...register("email", {required: true})}
                        placeholder={isEn ? "Email" : "Пошта"}
                        className={inputStyle}
                    />
                    {errors.email && <div className={errorStyle}>{emailError}</div>}
                </div>

                <div className="mb-4 relative mb-9">
                    <input
                        type="text"
                        {...register("phone", {
                            required: true,
                            pattern:
                                /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/,
                        })}
                        maxLength="17"
                        placeholder={isEn ? "Phone (099) 999-99-99" : "Тел. (099) 999-99-99"}
                        onChange={(event) => {
                            const {value} = event.target;
                            event.target.value = normalizeTel(value);
                        }}
                        name="phone"
                        className={inputStyle + " " + (errors.phone ? "form-control text-amber-700" : "form-control")}
                    />
                    {errors.phone && (
                        <div className={errorStyle}>{phoneError}</div>
                    )}
                </div>

                <button type="submit" name="submit" className="relative submit-form 
                    font-extrabold text-[22px] text-[#245864] uppercase inline-flex items-center justify-between gap-3 cursor-pointer
                    bg-[#F5D858] py-2 pl-3 pr-4 w-full sm:max-w-[250px] hover:bg-[#F5D858]/60 transition-colors duration-300">
                    Надіслати
                </button>

                <input name="site_name" {...register("site_name")} type="hidden" value={domain}/>
                <input name="price" {...register("price")} type="hidden" value="2500"/>
                <input name="local" {...register("local")} type="hidden" value={isEn}/>
                <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source}/>
                <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium}/>
                <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign}/>
                <input name="utm_content" {...register("utm_content")} type="hidden" value={utm_content}/>
                <input name="position" {...register("position")} type="hidden" value="position"/>
                <input name="user_agent" {...register("user_agent")} type="hidden"/>
                <input name="user_ip" {...register("user_ip")} type="hidden"/>
                <input name="fbc" type="hidden" {...register("fbc")} />
                <input name="fbp" type="hidden" {...register("fbp")} />
                {/*<div>*/}
                {/*    <a href="https://forms.gle/Dnah485hScw5fTJT7"*/}
                {/*       target="_blank"*/}
                {/*       className="text-sm text-[#494D4E] hover:text-black w-full max-w-max font-normal py-2 inline-flex items-center cursor-pointer max-sm:col-span-2">Корпоративним*/}
                {/*        клієнтам</a>*/}
                {/*</div>*/}

                <div
                    className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#003366] " + preloader}>
                    <div className="flex text-2xl justify-center items-center">
                        <FaRegCheckCircle className="mr-3"/>
                        <span>{waitText}</span>
                    </div>
                </div>
            </form>
        </div>
    );
}
